module.exports = __webpack_public_path__ + "static/images/components/VehicleType/images/SPG-prem-tiny.430c66d4.png";


//////////////////
// WEBPACK FOOTER
// ./components/VehicleType/images/SPG-prem-tiny.png
// module id = 2713
// module chunks = 11